module.exports = __webpack_public_path__ + "img/szw1.c0194a30.jpg";